<template>
  <div class="w-full p-4 mt-8 text-center rounded-md" :class="isSelected ? customClass + ' text-white cursor-default' : 'bg-white border-blue-700 cursor-pointer'">
    <div class="font-bold mb-1" dir="ltr" v-text="phone" />
    <div class="text-sm" v-text="price" />
  </div>
</template>

<script setup>
defineProps({ phone: String, price: String, isSelected: Boolean, customClass: String });
</script>
